module.exports = __webpack_public_path__ + "static/media/najm-status.be3b5c99.svg";